import React, { useState } from "react";
import { Sidebar, Segment, Button, Table } from "semantic-ui-react";

const AcronymsSidebar = ({ acronymsData }) => {
  const [visible, setVisible] = useState(false);

  const toggleSidebar = () => {
    setVisible(!visible);
  };

  return (
    <>
      <Button onClick={toggleSidebar}>
        {visible ? "Hide Acronyms" : "Show Acronyms"}
      </Button>
      <Sidebar
        as={Segment}
        animation="overlay"
        direction="right"
        visible={visible}
        width="very wide"
      >
        <Button
          icon="close"
          onClick={toggleSidebar}
          style={{ position: "absolute", top: "1rem", right: "1rem", zIndex: 10 }}
        />
        <div style={{ marginTop: "3rem" }}>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Acronym</Table.HeaderCell>
                <Table.HeaderCell>Definition</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {acronymsData &&
                Object.entries(acronymsData).map(([acronym, definition]) => (
                  <Table.Row key={acronym}>
                    <Table.Cell>{acronym}</Table.Cell>
                    <Table.Cell>{definition}</Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
      </Sidebar>
    </>
  );
};

export default AcronymsSidebar;
